import Image from 'next/image';

const TSlogo = () => {
  return (
    <Image
      src='/images/app-icons/logo.svg'
      className='logo'
      alt='Tulio Solorzano'
      width={48}
      height={48}
      priority
    />
  );
};

export default TSlogo;
